/* src/app/forms/produtos/viavarejo/viavarejo-attribute/viavarejo-attribute.component.scss */
:host {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.close {
  float: right;
  margin-top: -10px !important;
  margin-right: -10px;
  cursor: pointer;
}
.cardnon {
  min-height: 135px;
  max-height: 135px;
}
.warn {
  position: absolute;
  font-size: 18px;
  color: red;
  margin-left: 6px;
}
.cardred {
  min-height: 135px;
  max-height: 135px;
  border-color: red;
}
.full {
  width: 100%;
}
.multi-field {
  display: flex;
  width: 100%;
  flex-flow: row;
}
.multi-field .left {
  float: left;
  width: 65%;
}
.multi-field .right {
  float: right;
  width: 30%;
}
.data-card {
  width: 100%;
  height: 100%;
  padding: 10px;
}
.mat-mdc-card-title {
  font-size: 90%;
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
  overflow: hidden;
}
.view-compon .content {
  position: relative;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  font-size: 120%;
  padding-bottom: 6px;
}
.content-main {
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 6px;
  overflow: auto;
}
actions-buttons {
  display: flex;
  flex-direction: column;
}
/*# sourceMappingURL=viavarejo-attribute.component.css.map */
